module.exports = __webpack_public_path__ + "img/tm.5f005d39.svg";